if (!customElements.get("collection-image-showcase")) {
  class CollectionImageShowcase extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        media: ".m-collection-image-showcase__media",
        tabs: ".m-collection-image-showcase__collections",
        template: "template",
      };

      this.domNodes = queryDomNodes(this.selectors, this);
      this.tabsContainer = this.domNodes.tabs;
      this.media = this.domNodes.media;
      this.template = this.querySelector(this.selectors.template);
      this.tabItems = this.tabsContainer
        ? this.tabsContainer.querySelectorAll(
            ".m-collection-image-showcase__link"
          )
        : [];
      this.templates = this.template
        ? this.template.content.cloneNode(true)
        : null;
      this.currentIndex = 0;
      this.currentMedia = null;
      this.selectedContent = null;
      this.sectionId = this.dataset.sectionId;

      this.init();
    }

    init() {
      if (!this.media || !this.templates || !this.tabItems.length) {
        return;
      }

      this.setActiveTab(0);

      this.tabItems.forEach((item) => {
        item.addEventListener("mouseenter", (event) => {
          this.handleMouseOver(event);
        });

        item.addEventListener(
          "touchstart",
          (event) => {
            this.handleTouchChange(event);
          },
          { passive: false }
        );

        item.addEventListener("focus", (event) => {
          this.handleFocus(event);
        });
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          if (event.detail.sectionId !== this.sectionId) {
            return;
          }

          const selectedBlock = event.target;
          const index = Number(selectedBlock.dataset.index);

          if (!Number.isNaN(index)) {
            this.setActiveTab(index);
          }
        });
      }
    }

    setActiveTab(tabIndex) {
      if (
        Number.isNaN(tabIndex) ||
        tabIndex < 0 ||
        tabIndex >= this.tabItems.length
      ) {
        return;
      }

      const currentLink = this.tabItems[this.currentIndex];
      const newLink = this.tabItems[tabIndex];
      const currentItem = currentLink
        ? currentLink.closest(".m-collection-image-showcase__item")
        : null;
      const newItem = newLink
        ? newLink.closest(".m-collection-image-showcase__item")
        : null;

      this.selectedContent = this.templates.querySelector(
        `.m-collection-image-showcase__images[data-index="${tabIndex}"]`
      );

      if (this.selectedContent) {
        this.media.appendChild(this.selectedContent);
      }

      const newMedia = this.selectedContent
        ? this.selectedContent
        : this.media.querySelector(
            `.m-collection-image-showcase__images[data-index="${tabIndex}"]`
          );

      if (currentItem) {
        currentItem.classList.remove("active");
      }

      if (this.currentMedia) {
        this.currentMedia.classList.remove("active");
      }

      if (currentLink) {
        currentLink.classList.remove("active");
        currentLink.removeAttribute("aria-current");
      }

      if (newItem) {
        newItem.classList.add("active");
      }

      if (newMedia) {
        newMedia.classList.add("active");
      }

      if (newLink) {
        newLink.classList.add("active");
        newLink.setAttribute("aria-current", "true");
      }

      this.currentIndex = tabIndex;
      this.currentMedia = newMedia;
    }

    handleMouseOver(event) {
      const link = event.currentTarget;
      const index = Number(link.dataset.index);

      if (link.classList.contains("active")) {
        return;
      }

      this.setActiveTab(index);
    }

    handleTouchChange(event) {
      const link = event.currentTarget;

      if (!link.classList.contains("active")) {
        event.preventDefault();

        const index = Number(link.dataset.index);

        if (!Number.isNaN(index)) {
          this.setActiveTab(index);
        }
      }
    }

    handleFocus(event) {
      const link = event.currentTarget;
      const index = Number(link.dataset.index);

      if (!link.classList.contains("active") && !Number.isNaN(index)) {
        this.setActiveTab(index);
      }
    }
  }

  customElements.define(
    "collection-image-showcase",
    CollectionImageShowcase
  );
}
